<template>
  <div class="grid justify-items-center h-screen w-full bg-gradient-to-r from-purple-300 to-blue-300 bg-cover">
    <div class="self-center">
    <button @click="startroom" class="border-2 text-xl shadow-2xl font-extrabold border-gray-500 bg-green-300 rounded border-solid px-20 py-4 hover:bg-green-200 ">Create Room</button>
    <div class="text-2xl font-bold m-4">Multiplayer Cubing</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',
  methods: {
    startroom() {
      const r = Math.random().toString(36).substring(7);
      this.$store.commit("changeId", {roomId: r})
      this.$store.commit("toggleHost")
      this.$router.push("/Pregame")
    }
  }
}
</script>
